export default "__VITE_ASSET__DFSKlSU1__"